declare global {
  interface Window {
    $chatwoot?: {
      isOpen?: boolean;
      toggle?: (action: 'open' | 'close') => void;
      toggleBubbleVisibility?: (action: 'show' | 'hide') => void;
    };
    chatwootSDK?: {
      run: (config: { websiteToken: string; baseUrl: string }) => void;
    };
    chatwootSettings?: Record<string, unknown>;
    __stagingPrototypeChatwootInitialized?: boolean;
    __stagingPrototypeChatwootOpenRequested?: boolean;
    __stagingPrototypeChatwootHideHandlersInitialized?: boolean;
  }
}

const CHATWOOT_BASE_URL = 'https://cx.televeda.com';
const CHATWOOT_WEBSITE_TOKEN = 'w5onJv59kPAG8eMPceHwRcVE';

function hideLauncherIfAvailable(): void {
  if (
    window.$chatwoot &&
    typeof window.$chatwoot.toggleBubbleVisibility === 'function'
  ) {
    window.$chatwoot.toggleBubbleVisibility('hide');
  }
}

function ensureHideHandlers(): void {
  if (window.__stagingPrototypeChatwootHideHandlersInitialized) return;
  window.addEventListener('chatwoot:ready', hideLauncherIfAvailable);
  window.addEventListener('chatwoot:close', hideLauncherIfAvailable);
  window.addEventListener('chatwoot:closed', hideLauncherIfAvailable);
  window.__stagingPrototypeChatwootHideHandlersInitialized = true;
}

function openIfReady(): void {
  if (!window.$chatwoot || typeof window.$chatwoot.toggle !== 'function') {
    return;
  }
  // Keep the floating bubble hidden — chat is only opened from Get Help / support CTAs.
  hideLauncherIfAvailable();
  window.$chatwoot.toggle('open');
}

export function launchSupportChat(): void {
  ensureHideHandlers();

  if (window.$chatwoot && typeof window.$chatwoot.toggle === 'function') {
    openIfReady();
    return;
  }

  window.__stagingPrototypeChatwootOpenRequested = true;

  const onReady = () => {
    if (window.__stagingPrototypeChatwootOpenRequested) {
      window.__stagingPrototypeChatwootOpenRequested = false;
      window.setTimeout(openIfReady, 0);
    }
  };
  window.addEventListener('chatwoot:ready', onReady, { once: true });

  if (window.__stagingPrototypeChatwootInitialized) {
    if (window.chatwootSDK) {
      window.setTimeout(openIfReady, 0);
    }
    return;
  }

  window.chatwootSettings = {
    position: 'right',
    type: 'standard',
    launcherTitle: 'Get Help',
    hideMessageBubble: true,
    showPopoutButton: false,
  };

  const runChatwoot = () => {
    if (!window.chatwootSDK || typeof window.chatwootSDK.run !== 'function') {
      return;
    }
    if (!window.__stagingPrototypeChatwootInitialized) {
      window.chatwootSDK.run({
        websiteToken: CHATWOOT_WEBSITE_TOKEN,
        baseUrl: CHATWOOT_BASE_URL,
      });
      window.__stagingPrototypeChatwootInitialized = true;
    }
    hideLauncherIfAvailable();
  };

  const existingScript = document.querySelector(
    `script[src="${CHATWOOT_BASE_URL}/packs/js/sdk.js"]`,
  ) as HTMLScriptElement | null;

  if (existingScript) {
    if (window.chatwootSDK) {
      runChatwoot();
    } else {
      existingScript.addEventListener('load', runChatwoot, { once: true });
    }
    return;
  }

  const script = document.createElement('script');
  script.src = `${CHATWOOT_BASE_URL}/packs/js/sdk.js`;
  script.async = true;
  script.onload = runChatwoot;
  document.head.appendChild(script);
}
